import { STYLE_LIST } from '../../config/dataConfig/FJImageToImageData';
import FJNetworkStore from '../../store/FJNetworkStore';
import FJUtil from '../../util/FJUtil';
import FJMessageStore from '../../store/FJMessageStore';
import FJLocalStore from '../../store/FJLocalStore';
import FJActionModal from './FJActionModal';
import FJConstant from '../../constants/FJConstant';
import FJImageStore from '../../store/FJImageStore';
import FJCompressedImageStore from '../../store/FJCompressedImageStore';
import FJS3Config from '../../config/FJS3Config';
import { setSliceCreationListAction, setSliceTaskStatusAction } from '../slices/FJSliceCommon';
import {
    setSliceGenerateQuantityAction,
    setSliceUploadImageInfoAction,
    setSlicePromptAction,
} from '../slices/FJSliceImageToImage';
import FJActionCommon from './FJActionCommon';
import FJConfig from '../../config/FJConfig';
import FJLoadLocalforageStore from '../../store/FJLoadLocalforageStore';
const SINGLE_PICTURE_COST_CREDITS = 2;
let f_eventId = null;
let f_currentTaskId = null;

const _uploadFileAndCompressed = async src => {
    const blob = await FJCompressedImageStore.simpleCompressImage(src);
    if (!blob) return '';
    const id = await FJUtil.hashEncode(blob);
    const key = FJConfig.originalImageKey + `${id}.png`;
    const result = await FJImageStore.upLoadFileToS3Async(blob, key);
    if (!result) return '';
    return FJS3Config.S3_SERVER_HOST + key;
};

const _limitJudgment = (hasFreeCreation, creditNumber, generateQuantity) => {
    if (generateQuantity * SINGLE_PICTURE_COST_CREDITS <= creditNumber) {
        //判断积分
        return true;
    } else if (hasFreeCreation && generateQuantity < 3) {
        //判断免费
        return true;
    } else return false;
};

const _imageToImage = async (data, dispatch) => {
    const idInfo = await FJNetworkStore.imgToImg(data);
    const { code, data: imgTaskData } = idInfo;
    if (code === 401) {
        dispatch(FJActionModal.showUpgradeModalAction());
        return;
    } else if (code === 214) {
        FJUtil.anonymousSignUp()
            .then(() => {
                dispatch(FJActionCommon.initProjectInfoAction(true));
            })
            .catch(e => console.log(e));
        return;
    }
    const eventId = imgTaskData?.event_id;
    if (!eventId) {
        throw new Error('create task error');
    }
    return eventId;
};
const _checkIsCurrentTask = id => {
    return id === f_currentTaskId;
};
const FJActionImageToImage = {
    resetAction: function () {
        return dispatch => {
            dispatch(setSlicePromptAction(''));
            dispatch(setSliceUploadImageInfoAction({}));
            // dispatch(setSliceGenerateQuantityAction(2));
            // dispatch(setSliceSelectStyleCategoryAction(0));
            // dispatch(setSliceSelectedStyleAction('green-art'));
        };
    },
    uploadImageAction: function (file) {
        return async dispatch => {
            const format = file.type;
            const isImage = FJUtil.isImage(file, true);
            const __imageError = () => {
                FJMessageStore.addMessage(
                    FJLocalStore._('unsupported-format-please-try-again-with-supported-formats'),
                    'error',
                );
                FJUtil.eaLog('img to img upload fail', { format });
            };
            if (!isImage) {
                __imageError();
            } else {
                FJUtil.loadImageFile(
                    file,
                    img => {
                        const info = {
                            src: img.src,
                            width: img.width,
                            height: img.height,
                        };
                        dispatch(setSliceUploadImageInfoAction(info));
                        const resolution = img.width + ' * ' + img.height;
                        FJUtil.eaLog('img to img upload success', { format, resolution });
                    },
                    __imageError,
                );
            }
        };
    },
    uploadImageUrlAction: function (url, options = {}) {
        return dispatch => {
            const { size, name, id } = options;
            const info = {
                name: name,
                src: url,
                width: size.width,
                height: size.height,
                id: id,
            };
            dispatch(setSliceUploadImageInfoAction(info));
        };
    },
    generateAction: function (options = {}) {
        return async (dispatch, getState) => {
            let { generateQuantity, prompt, selectedStyle, uploadImageInfo } = getState().imageToImage;
            let { creditNumber, freeNumCreation } = getState().common;
            const hasFreeCreation = freeNumCreation > 0;
            const { paramCount, paramPrompt, paramStyle, paramImageInfo, paramIsUploadS3 } = options;
            let isUploadS3 = paramIsUploadS3 || false;

            paramPrompt && (prompt = paramPrompt);
            paramStyle && (selectedStyle = paramStyle);
            paramImageInfo && (uploadImageInfo = paramImageInfo);
            paramCount && (generateQuantity = paramCount);

            const category = STYLE_LIST.find(ca => ca.list.find(item => item.value === selectedStyle));
            const styleInfo = category ? category.list.find(item => item.value === selectedStyle) : {};
            let _startTime = new Date().getTime();
            const currentTaskId = new Date().getTime();
            f_currentTaskId = currentTaskId;
            f_eventId = null;
            const isUseFree =
                hasFreeCreation &&
                generateQuantity * SINGLE_PICTURE_COST_CREDITS > creditNumber &&
                generateQuantity < 3;
            const buryData = {
                number: generateQuantity,
                style: styleInfo.buryName || selectedStyle,
                type: isUseFree ? 'free trail' : 'use credit',
            };
            FJUtil.eaLog('img to img click generate', buryData);

            if (!uploadImageInfo.src) {
                FJMessageStore.addMessage(FJLocalStore._('please-upload-an-image-first'), 'error');
                return;
            }
            let imageUrl = '';
            const placeHolderList = FJUtil.createPlaceHolderList({
                count: generateQuantity,
                uploadImageInfo,
                selectedStyle,
                prompt,
                isUploadS3,
            });
            dispatch(setSliceCreationListAction(placeHolderList));
            dispatch(setSliceTaskStatusAction(FJConstant.START));
            const __errorToInitStatus = () => {
                dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
                dispatch(setSliceCreationListAction([]));
            };
            const __errorAndReLoad = () => {
                const creationList = getState().common.creationList;
                const reLoadList = creationList.map(i => ({
                    ...i,
                    isLoading: false,
                    isReload: true,
                }));
                dispatch(setSliceCreationListAction(reLoadList));
                dispatch(setSliceTaskStatusAction(FJConstant.ERROR));
            };

            const userSpaceType = await FJUtil.checkUserSpace({
                errorCallback: () => {
                    FJMessageStore.addMessage(
                        FJLocalStore._('failed-to-generate-the-image-please-try-it-again'),
                        'error',
                    );
                    FJUtil.eaLog('img to img click generate fail', buryData);
                },
            });
            if (userSpaceType > 0) {
                dispatch(FJActionCommon.userSpaceChangeAction(userSpaceType));
                __errorToInitStatus();
                return;
            }

            if (!_checkIsCurrentTask(currentTaskId)) return;

            const isExceedCredits = generateQuantity * SINGLE_PICTURE_COST_CREDITS > creditNumber;
            if ((hasFreeCreation && isExceedCredits && generateQuantity > 2) || (!hasFreeCreation && isExceedCredits)) {
                dispatch(FJActionModal.showUpgradeModalAction());
                __errorToInitStatus();
                return;
            }
            const isFree = isExceedCredits && hasFreeCreation;
            try {
                if (isUploadS3) {
                    imageUrl = uploadImageInfo.src;
                } else {
                    imageUrl = await _uploadFileAndCompressed(uploadImageInfo.src);
                    isUploadS3 = true;
                }
                if (!_checkIsCurrentTask(currentTaskId)) return;
                if (!imageUrl) {
                    __errorToInitStatus();
                    FJMessageStore.addMessage(FJLocalStore._('failed-to-upload-please-try-again'), 'error');
                    return;
                }

                const data = {
                    image: imageUrl,
                    numOutputs: generateQuantity,
                    prompt,
                    style: selectedStyle,
                };
                const eventId = await _imageToImage(data, dispatch);

                if (!_checkIsCurrentTask(currentTaskId)) return;
                if (!eventId) {
                    __errorToInitStatus();
                    return;
                }
                dispatch(FJActionCommon.updateFreezeInfoAction());
                f_eventId = eventId;
                const tool = FJUtil.getToolName();
                FJUtil.eaLog('ai tool start generating', { 'credit&free': isFree ? 'free' : 'credit', tool });
                const callback = data => {
                    const { type, waitingEndTime } = data;
                    let _endTime = new Date().getTime();
                    const queuingDuration = FJUtil.getTimeDiff(_startTime, waitingEndTime);
                    const generatingDuration = FJUtil.getTimeDiff(waitingEndTime, _endTime);
                    queuingDuration && (buryData['queuing duration'] = queuingDuration);
                    generatingDuration && (buryData['generating duration'] = generatingDuration);
                    if (type === FJConstant.ERROR) {
                        FJUtil.eaLog('img to img click generate fail', buryData);
                        __errorAndReLoad();
                    } else if (type === FJConstant.SUCCESS) {
                        FJUtil.eaLog('img to img click generate success', buryData);
                        FJUtil.setLocalStorage();
                        FJUtil.eaLog('ai tool generate success', {
                            tool: FJUtil.getToolName(),
                            'credit&free': isFree ? 'free' : 'credit',
                        });
                    }
                };
                dispatch(
                    FJActionCommon.pollingTaskAction([f_eventId], {
                        callback,
                        progressNumber: generateQuantity,
                    }),
                );
            } catch (e) {
                __errorAndReLoad();
                FJUtil.eaLog('img to img click generate fail', buryData);
            }
        };
    },
    reGenerateAction: function (id) {
        return async (dispatch, getState) => {
            const { creationList } = getState().common;
            const item = creationList.find(item => item.id === id);

            const data = {
                paramCount: creationList.length,
                paramPrompt: item.prompt,
                paramStyle: item.style,
                paramImageInfo: {
                    src: item.uploadS3Url || item.originalUrl,
                    width: item.width,
                    height: item.height,
                },
                paramIsUploadS3: item.isUploadS3,
            };
            dispatch(FJActionImageToImage.generateAction(data));
        };
    },
    updateGenerateQuantityAction: function (number) {
        return (dispatch, getState) => {
            const { generateQuantity } = getState().imageToImage;
            const { freeNumCreation, creditNumber } = getState().common;
            const hasFreeCreation = freeNumCreation > 0;

            if (
                !_limitJudgment(hasFreeCreation, creditNumber, number) &&
                number > generateQuantity &&
                FJUtil.isLogin()
            ) {
                dispatch(FJActionModal.showUpgradeModalAction());
                return;
            }
            dispatch(setSliceGenerateQuantityAction(number));
        };
    },
    cancelTaskAction: function () {
        return async dispatch => {
            try {
                f_currentTaskId = null;
                f_eventId && (await FJNetworkStore.cancelTask(f_eventId));
            } catch (e) {
                FJMessageStore.addMessage(FJLocalStore._('cancel-to-delete-please-try-again'), 'error');
            } finally {
                dispatch(setSliceCreationListAction([]));
                dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
            }
        };
    },
    loadImageToImagePageAction: function () {
        return async dispatch => {
            const recId = FJUtil.getQueryString(FJConstant.REC_ID);
            const recIdInfo = recId ? JSON.parse(window.localStorage.getItem(recId)) : null;
            if (recIdInfo) {
                if (!window.isEditPage) {
                    const url = location.origin + location.pathname;
                    FJUtil.changeLocation(url);
                }
                window.localStorage.removeItem(recId);
                const { fileList, avator } = recIdInfo;
                if (fileList) {
                    const fileInfo = fileList[0]?.info;
                    if (!fileInfo) return;

                    const data = await FJLoadLocalforageStore.getItem(fileList[0].key);
                    const file = new File([data.data], fileInfo.name, { type: fileInfo.type });
                    dispatch(FJActionImageToImage.uploadImageAction(file));
                } else if (avator) {
                    const blob = await FJUtil.getBlobByUrl(avator);
                    dispatch(FJActionImageToImage.uploadImageAction(blob));
                }
            }
        };
    },
};
export default FJActionImageToImage;
